import React from 'react';
import { Section } from '@/components/Common';
import { Form, Grid } from '@mairistem/composants';

interface InformationsComplementairesProps {
  conforme: boolean;
  annule: boolean;
  selectedDeclarationType?: string;
  isDissolutionMode: boolean;
  onChange: (
    _e: any,
    data: { name: string; value?: any; checked?: boolean },
  ) => void;
}

const InformationsComplementaires = (
  props: InformationsComplementairesProps,
) => {
  const {
    conforme,
    annule,
    selectedDeclarationType,
    isDissolutionMode,
    onChange,
  } = props;

  const handleSituationChange = React.useCallback(
    (field: string, value: boolean) => {
      onChange(null, {
        name: `conventionDeclaration.${field}`,
        value,
      });
    },
    [onChange],
  );

  return (
    <Section
      data-testid="assistant-pacs-informations-complementaires"
      title="INFORMATIONS COMPLÉMENTAIRES"
      style={{
        display: 'flex',
        justifyContent:
          selectedDeclarationType !== 'modificative' ? 'center' : 'start',
      }}
    >
      <Form>
        <Grid padded>
          <Grid.Row>
            <Grid.Column width={8}>
              <Form.Checkbox
                label="Déclaration conforme"
                data-testid="assistant-pacs-declaration-conforme"
                checked={conforme}
                onChange={(_e, data) =>
                  handleSituationChange('conforme', data?.checked)
                }
              />
            </Grid.Column>
            {!isDissolutionMode &&
              selectedDeclarationType !== 'modificative' && (
                <Grid.Column width={8}>
                  <Form.Checkbox
                    label="Déclaration annulée"
                    data-testid="assistant-pacs-declaration-annulee"
                    checked={annule}
                    onChange={(_e, data) =>
                      handleSituationChange('annule', data?.checked)
                    }
                  />
                </Grid.Column>
              )}
          </Grid.Row>
        </Grid>
      </Form>
    </Section>
  );
};

export default InformationsComplementaires;
